
import { defineComponent, PropType } from 'vue'
import { Dataset } from '~/types/reportTypes'
import { issueCategoryMap } from '~/utils/reports'
import { toSentenceCase } from '~/utils/string'
import { getIssueTypeIcon } from '~/utils/ui'

/**
 * Legends component for reports charts
 */
export default defineComponent({
  name: 'ReportChartLegend',
  props: {
    datasets: {
      type: Array as PropType<Array<Dataset>>,
      required: true
    },
    layout: {
      type: String,
      default: 'flex'
    },
    menuDirection: {
      type: String,
      default: 'left'
    },
    menuPlacement: {
      type: String,
      default: 'bottom'
    },
    othersDatasetNames: {
      type: Array as PropType<Array<string>>,
      default: () => []
    }
  },
  computed: {
    isGridLayout(): boolean {
      return this.layout === 'grid'
    }
  },
  methods: {
    getIcon: getIssueTypeIcon,
    toSentenceCase,
    /**
     * Method to format dataset name.
     * If name is of a issue category, we map it to its desired label.
     *
     * @param {string} name
     * @returns {string}
     */
    datasetNameFormatter(name: string): string {
      const label = issueCategoryMap[name]?.label ?? name
      return toSentenceCase(label, false)
    }
  }
})
